<template>
    <div class="select currencies">
        <select @change="onChange($event)" v-model="currency">
            <option :value="currency.id.toUpperCase()"  v-for="currency in currency_picker">
                {{ currency.id.toUpperCase() }}
            </option>
        </select>
    </div>
</template>

<script>
    export default {
        props: {
            currency_picker: Array,
            currency_display: String
        },

        data(){
            return {
                currency: ""
            }
        },

        methods: {
            onChange(event){
                const param = new URLSearchParams(window.location.search);
                param.set('currency', event.target.value.toLowerCase());
                window.location.href = window.location.pathname + "?" + param.toString();
            }
        },

        mounted() {
            this.currency = this.currency_display;
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/_mixin.scss";
    .currencies {
        &::after{
            border-color: #ffffff;
        }
        select{
            background-color: transparent;
            color: #ffffff;
            width: 100%;
        }
    }
</style>
